import * as React from "react";
import browserHistory from "web_modules/redux/history";
import { Button } from "react-bootstrap";

import { getFileDownloadBaseURL } from "config";
import APIClient from "../../APIClient";
import { setUserContext } from "../../utils/sentry";
import { Column, TRUSTable } from "../../shared/TRUSTable";

interface PipelineProps {}

const table = data => (
  <TRUSTable
    data={data.map(row => ({
      ...row,
      id: row.lead_number,
      is_archived: row.is_archived === "true" ? "Yes" : "No",
    }))}
    className="table table-striped table-hover"
  >
    <Column header="App ID" dataKey="loan_application_id" />
    <Column header="Borrower Name" dataKey="borrower_name" />
    <Column header="Loan Officer" dataKey="loan_officer" />
    <Column header="Underwriter" dataKey="underwriter" />
    <Column header="Created Date" dataKey="created_at" />
    <Column header="Credit Application Date" dataKey="credit_application_date" />
    <Column header="Borrower's auth signed date" dataKey="registration_date" />
    <Column header="Credit Score" dataKey="credit_score" />
    <Column header="RESPA Date" dataKey="application_complete" />
    <Column header="Loan Status" dataKey="loan_status" />
    <Column header="Loan Status Date" dataKey="loan_status_date" />
    <Column header="Loan Decision" dataKey="loan_decision" />
    <Column header="Loan Decision Date" dataKey="loan_decision_date" />
    <Column header="COE Date" dataKey="closing_date" />
    <Column header="Disbursement Date" dataKey="disbursement_date" />
    <Column header="Property State" dataKey="property_state" />
    <Column header="Borrower Estimated Loan Amount" dataKey="borrower_estimated_loan_amount" />
    <Column header="Archived" dataKey="is_archived" />
  </TRUSTable>
);

export default class Pipeline extends React.Component<PipelineProps, any> {
  state = { data: [] };

  componentDidMount() {
    APIClient.get("/session").then((resp: any) => {
      setUserContext(resp);
      if (resp.user_type === "operator") {
        this.setState({ ...resp });
        this.fetchData();
      } else {
        browserHistory.push(
          `/operators/login?redirect=${encodeURIComponent("/underwriter/pipeline")}`,
        );
      }
    });
  }

  fetchData() {
    APIClient.get("/uw/json_reports/pipeline").then(({ data }) => {
      this.setState({ data });
    });
  }

  render() {
    const { data } = this.state;
    return (
      <>
        <div className="static-container row">
          <div className="col-md-8">
            <h1>Loan Pipeline</h1>
          </div>
          <div className="text-right col-md-4">
            <Button
              className="btn-sm"
              onClick={() => {
                APIClient.get("/uw/reports/pipeline")
                  .then(({ filename, s3_key }) => {
                    window.location.href = getFileDownloadBaseURL(s3_key, filename);
                  })
                  .catch(_ => {
                    alert(
                      `There was an error downloading the pipeline report. Please try again or notify #engineering.`,
                    );
                  });
              }}
            >
              Download Pipeline Report
            </Button>
          </div>
        </div>
        {data && table(data)}
      </>
    );
  }
}
